import { API } from "aws-amplify";
import {
  IHotelConf,
  IRoomType,
  IRatePlanConf,
  IDeleteRoomType,
  IDeleteRateplan,
} from "../models/api.models";

export class ConfigApi {
  static async getHotelConfig(hotelId: number): Promise<IHotelConf> {
    if (isNaN(hotelId)) {
      return {} as IHotelConf;
    } else {
      return API.get("config", `/hotels/${hotelId}`, {});
    }
  }

  static async addNewHotel(body: IHotelConf) {
    return await API.post("config", `/hotels`, { body });
  }

  static async deleteHotel(hotelId: number): Promise<IHotelConf> {
    return API.del("config", `/hotel/${hotelId}`, {});
  }

  static async updateHotelConfig(body: IHotelConf) {
    return await API.patch("config", `/hotels/${body.hotel.hotelId}`, { body });
  }

  static async writeRoomType(body: IRoomType) {
    return await API.put("config", `/rooms/${body.hotelId}/${body.id}`, {
      body,
    });
  }

  static async writeRateplan(body: IRatePlanConf) {
    return await API.put("config", `/rates/${body.hotelId}/${body.id}`, {
      body,
    });
  }

  static async deleteRoomType(body: IDeleteRoomType) {
    return await API.del("config", `/rooms/${body.hotelId}/${body.rtId}`, {
      body,
    });
  }
  static async deleteRateplan(body: IDeleteRateplan) {
    return await API.del("config", `/rates/${body.hotelId}/${body.id}`, {
      body,
    });
  }
}
